module.exports = __webpack_public_path__ + "static/media/savemoney.57dfa956.svg";